import { render, staticRenderFns } from "./header.vue?vue&type=template&id=88f8845a&scoped=true&lang=pug&"
import script from "./header.vue?vue&type=script&lang=ts&"
export * from "./header.vue?vue&type=script&lang=ts&"
import style0 from "./header.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./header.vue?vue&type=style&index=1&id=88f8845a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f8845a",
  null
  
)

export default component.exports